/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: '#000000',
    padding: '10px',
    height: 36,
    minWidth: 180,
    borderRadius: 2,
    fontSize: 14,
  },
}));
